const consulta_melhor_sequencial_de_matricula = {
  path: "/consulta-melhor-sequencial-de-matricula",
  redirect: "/consulta-melhor-sequencial-de-matricula",
  meta: {
    breadCrumb:
      "Planejamento de Matrícula - Gerar Melhor Sequencial de Matrícula",
  },
  children: [
    {
      path: "/consulta-melhor-sequencial-de-matricula",
      name: "consulta-melhor-sequencial-de-matricula",
      component: () =>
        import(
          "@/views/ConsultaMelhorSequencialDeMatricula/ConsultaMelhorSequencialDeMatriculaHome.vue"
        ),
    },
    {
      path: "/consulta-melhor-sequencial-de-matricula/detalhes/:id",
      name: "consulta-melhor-sequencial-de-matricula-detalhes",
      component: () =>
        import(
          "@/views/ConsultaMelhorSequencialDeMatricula/ConsultaMelhorSequencialDeMatriculaDetalhes.vue"
        ),
    },
  ],
};

export { consulta_melhor_sequencial_de_matricula };
